<div class="clients-page">

  <div class="lx-page-header">
    <div>
      <p class="lx-page-eyebrow">{{ 'page.clients_eyebrow' | translate }}</p>
    </div>
    <div class="clients-filter-bar">
      <select
        class="clients-search-field"
        [(ngModel)]="clientSearchField"
        (ngModelChange)="clientSearchFieldChange($event)"
      >
        <option value="name">{{ 'lbl.name' | translate }}</option>
        <option value="phone">{{ 'lbl.phone' | translate }}</option>
        <option value="email">{{ 'lbl.email' | translate }}</option>
      </select>
      <div class="clients-search-wrap">
        <span class="material-symbols-outlined clients-search-icon">search</span>
        <input
          type="search"
          (input)="clientNameSearch($event)"
          [(ngModel)]="clientNameValue"
          class="clients-search-input"
          [placeholder]="'ph.search_clients' | translate"
        />
      </div>
    </div>
  </div>

  <div class="app-card clients-table-card">
    <div class="lx-table-wrap">
      <table
        mat-table
        [dataSource]="allClientsArr"
        matSort
        matSortDirection="desc"
        matSortDisableClear
        class="clients-mat-table"
      >
        <ng-container matColumnDef="#">
          <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>{{ 'lbl.uid' | translate }}</th>
          <td mat-cell *matCellDef="let element; let i = index">{{ element?.id }}</td>
        </ng-container>

        <ng-container matColumnDef="username">
          <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>{{ 'lbl.client' | translate }}</th>
          <td mat-cell *matCellDef="let row">
            <div class="client-name-cell">
              <div class="client-avatar">{{ (row?.first_name || row?.username || '?').charAt(0).toUpperCase() }}</div>
              <div>
                <p class="client-name">{{ row?.first_name ? row?.first_name + ' ' + row?.last_name : (row?.username | titlecase) }}</p>
                <p class="client-sub">{{ row?.email }}</p>
              </div>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="phoneNumber">
          <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>{{ 'lbl.phone' | translate }}</th>
          <td mat-cell *matCellDef="let row">{{ row?.phone_number }}</td>
        </ng-container>

        <ng-container matColumnDef="emailAddress">
          <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>{{ 'lbl.email' | translate }}</th>
          <td mat-cell *matCellDef="let row">{{ row?.email }}</td>
        </ng-container>

        <ng-container matColumnDef="ordersCount">
          <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>{{ 'lbl.orders' | translate }}</th>
          <td mat-cell *matCellDef="let row">{{ row?.orders?.length }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"
          (mouseover)="onRowHovered(row)"
          (mouseleave)="handleMouseLeave()"
          (mousedown)="clientDetails(row.id)"
          [class.row-selected]="row === selectedRow"
        ></tr>
      </table>
    </div>

    <div class="lx-empty" *ngIf="allClientsArr?.length === 0">
      <div class="lx-empty-icon">
        <span class="material-symbols-outlined">people</span>
      </div>
      <h3>{{ 'empty.clients' | translate }}</h3>
      <p>{{ 'empty.clients_sub' | translate }}</p>
    </div>

    <mat-paginator
      [pageSize]="10"
      [length]="totalCount"
      [pageIndex]="page - 1"
      (page)="changePage($event)"
    ></mat-paginator>
  </div>

</div>
